import AltLayout from 'Nori/Layout/AltLayout';
import Hero from 'Custom/Hero';
import Warnings from 'Custom/Warnings';
import RichText from 'Custom/RichText';
import Container from 'Nori/Container';
import Button from 'Nori/Button';
import SplitContent from 'Custom/Split/SplitContent';
import AjustableImage from 'Custom/AjustableImage';
import ConditionsTable from 'Custom/Table/ConditionsTable';
import FinderSimple from 'Custom/Finder/FinderSimple';
import { Table } from 'Custom/Table';
import { SPANISH_JOB_CODE } from 'Custom/Footer/es/Footer.utils';

import {
  SE_TABLE_1,
  SE_TABLE_2,
  SE_TABLE_3,
  CONDITIONS_TABLE,
  WARNINGS_ITEMS_LIST,
  WARNINGS_TITLE,
} from 'Utils/es/side-effects';

import QUESTIONS_IMAGE from 'Images/misc/question-yellow.webp';
import PLUS_IMAGE from 'Images/misc/plus-gold.webp';

import styles from 'styles/pages/sideEffects.module.scss';

const HEAD = {
  title:
    'Riesgos y efectos secundarios de NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  keywords: 'efectos secundarios de nexplanon',
  description:
    'Revise los posibles riesgos y efectos secundarios de NEXPLANON® (etonogestrel implant) 68 mg Radiopaque, incluidos los efectos secundarios más comunes y quiénes no deben usarlo.',
  hreflang: 'es-us',
};

const HERO_IMAGE = {
  src: PLUS_IMAGE,
  width: 403,
};

const HERO_IMAGE_MOBILE = {
  src: PLUS_IMAGE,
};

export default function SideEffectsSpanish() {
  return (
    <AltLayout head={HEAD} jobCode={SPANISH_JOB_CODE}>
      <Hero
        title={
          <>
            EFECTOS SECUNDARIOS DE <strong>NEXPLANON</strong>
          </>
        }
        background="primaryLight"
        variant="overlap"
        image={HERO_IMAGE}
        mobileImage={HERO_IMAGE_MOBILE}
        imageBreakpoint="xl"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Hero"
        data-design-module_name="EFECTOS SECUNDARIOS DE NEXPLANON"
        data-design-module_no="01"
      >
        <RichText>
          <h2>
            aprende sobre los efectos secundarios más comunes, los posibles
            riesgos de usar NEXPLANON e información sobre quién no debe usar
            NEXPLANON
          </h2>
        </RichText>
      </Hero>

      <Container
        size="md"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="¿cuáles son los efectos secundarios más frecuentes de NEXPLANON?"
        data-design-module_no="02"
      >
        <RichText className={styles.tableWrapper}>
          <h2>
            ¿cuáles son los efectos secundarios más frecuentes de NEXPLANON?
          </h2>
          <Table
            className="compact"
            content={SE_TABLE_1}
            title="¿cuáles son los efectos secundarios más frecuentes de NEXPLANON?"
          />
        </RichText>
      </Container>

      <Warnings
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name={WARNINGS_TITLE}
        data-design-module_no="03"
        title={WARNINGS_TITLE}
        itemsList={WARNINGS_ITEMS_LIST}
      />

      <ConditionsTable
        showIcon={false}
        {...CONDITIONS_TABLE}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="informe a su profesional de la salud si tiene o ha tenido alguna de estas afecciones."
        data-design-module_no="04"
      >
        <RichText>
          <h2 className="mb">
            informe a su profesional de la salud si tiene o ha tenido alguna de
            estas afecciones.
          </h2>
          <p className="intro">
            Su profesional de la salud puede sugerirle un método anticonceptivo
            diferente.
          </p>
        </RichText>
      </ConditionsTable>

      <div
        className={styles.tableBg}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="¿cuáles son los posibles riesgos de NEXPLANON?"
        data-design-module_no="05"
      >
        <Container size="md">
          <RichText className={styles.tableWrapper}>
            <h2>¿cuáles son los posibles riesgos de NEXPLANON?</h2>
            <Table
              className="compact"
              content={SE_TABLE_2}
              title="¿cuáles son los posibles riesgos de NEXPLANON?"
            />
          </RichText>
        </Container>
      </div>

      <Container
        size="md"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="llame de inmediato al médico si usted tiene:"
        data-design-module_no="06"
      >
        <RichText className={styles.tableWrapper}>
          <h2>llame de inmediato al médico si usted tiene:</h2>
          <Table
            content={SE_TABLE_3}
            title="llame de inmediato al médico si usted tiene:"
          />
        </RichText>
      </Container>

      <FinderSimple
        designModuleNo="07"
        title="¿lista para NEXPLANON?"
        buttonLabel="Encuentra un médico"
        buttonHref="/what-is-nexplanon/#find-a-doctor"
      >
        Encuentra un profesional de la salud capacitado e inicia la
        conversación.
      </FinderSimple>

      <SplitContent
        variant="questions"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="¿Tiene más preguntas?"
        data-design-module_no="08"
      >
        <AjustableImage
          background="secondary4Light"
          image={{ src: QUESTIONS_IMAGE }}
        />
        <>
          <RichText>
            <h2>¿Tiene más preguntas?</h2>
            <p className="intro">Consulte las preguntas frecuentes</p>
            <p className="intro">Podrían tener las respuestas que busca</p>
          </RichText>
          <Button
            type="secondary4"
            href="/es-us/preguntas/"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label="Vea las preguntas frecuentes"
            data-design-nori_id="Inline Content"
            data-design-module_name="¿Tiene más preguntas?"
            data-design-module_no="08"
          >
            Vea las preguntas frecuentes
          </Button>
        </>
      </SplitContent>
    </AltLayout>
  );
}
